import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppOverlayContainer extends OverlayContainer {
    protected override _createContainer(): void {
        const container: HTMLDivElement = document.createElement('div');
        container.classList.add('cdk-overlay-container');

        const element: Element | null =
            document.querySelector('.cms-ride-command');
        if (element !== null) {
            element.appendChild(container);
            this._containerElement = container;
        }
    }
}
